import { Component, ElementRef, HostListener, OnInit, Renderer2 } from '@angular/core';
import { Store } from '@ngrx/store';
import { CategoryInterface } from '../../../domain/entites/footer-themes.model';
import { FooterFacade } from '../../../domain/facates/footer-themes.facades';
import { Route, Router } from '@angular/router';
import { trigger, transition, style, animate } from '@angular/animations';
import { LanguageService } from 'imakeapp-shared';

@Component({
  selector: 'app-footer-two',
  templateUrl: './footer-two.component.html',
  styleUrls: ['./footer-two.component.css'],
    animations: [
    trigger('scrollAnimation', [
      transition(':enter', []),
      transition('* => *', [
        style({ opacity: 0, transform: 'translateY(10px)' }),
        animate('500ms', style({ opacity: 1, transform: 'translateY(0)' }))
      ])
    ])
  ]
})
export class FooterTwoComponent implements OnInit {



  categories: CategoryInterface[] = [];
  lang =  'en';
  show_nav_btn: boolean = false;
  showScrollAnimation = false;

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    const windowHeight = window.innerHeight;

    // Customize the scroll position and window height values according to your needs
    if (scrollPosition > windowHeight / 2) {
      this.showScrollAnimation = true;
    } else {
      this.showScrollAnimation = false;
    }
  }

  constructor(
    private store: Store,
    private facade: FooterFacade,
    private router :Router,
    private language_s: LanguageService,
    private renderer: Renderer2, private elementRef: ElementRef

  ) { }

  ngOnInit(): void
  {

    this.set_lang();

    this.facade.get_categories();

    this.listen_to_data();

  }


  set_lang()
  {

    ;

  }



  listen_to_data()
  {

    // get categories
    this.facade.categories_selector$.subscribe(
      (response)=>{
        this.categories = response;
      },
      (err)=>{
        console.error(err);
      }
    );

  }

  redirectToProductcategoryByCAT(catid:any)
  {
      this.router.navigate(['/products/products-list'],  {
        queryParams:  {category_id:catid}
      }).then(()=>{

        setTimeout(() => {
          this.navigate_top()
        }, 500);
            });;


  }
  redirectToProductcategoryBySubCAT(subcatid:any)
  {

      this.router.navigate(['/products/products-list'],  {
        queryParams:  {SubCatId:subcatid}
      }).then(()=>{
setTimeout(() => {
  this.navigate_top()
}, 500);

      });;


  }
  navigate_top() {
    const section = document.getElementById('scrolltotop');
    section?.scrollIntoView({ behavior: 'smooth' });

  }

  toggle_footer_menu(menu: any, state: boolean, show_btn: any, hide_btn: any)
  {

    if ( state )
    {
      menu.classList.add('show');
      show_btn.classList.add('hide_btn');
      hide_btn.classList.remove('hide_btn');

    }
    else
    {
      menu.classList.remove('show');
      show_btn.classList.remove('hide_btn');
      hide_btn.classList.add('hide_btn');
    }

    this.show_nav_btn = state;

  }




}
